// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IReportSummaryGroupDtoPlanOmnibusBalanceSummaryRecordDto } from './IReportSummaryGroupDtoPlanOmnibusBalanceSummaryRecordDto';
import {
    IReportSummaryGroupDtoPlanOmnibusBalanceSummaryRecordDtoFromJSON,
    IReportSummaryGroupDtoPlanOmnibusBalanceSummaryRecordDtoFromJSONTyped,
    IReportSummaryGroupDtoPlanOmnibusBalanceSummaryRecordDtoToJSON,
    IReportSummaryGroupDtoPlanOmnibusBalanceSummaryRecordDtoToJSONTyped,
} from './IReportSummaryGroupDtoPlanOmnibusBalanceSummaryRecordDto';
import type { IPlanOmnibusBalanceSummaryRecordDto } from './IPlanOmnibusBalanceSummaryRecordDto';
import {
    IPlanOmnibusBalanceSummaryRecordDtoFromJSON,
    IPlanOmnibusBalanceSummaryRecordDtoFromJSONTyped,
    IPlanOmnibusBalanceSummaryRecordDtoToJSON,
    IPlanOmnibusBalanceSummaryRecordDtoToJSONTyped,
} from './IPlanOmnibusBalanceSummaryRecordDto';

/**
 * 
 * @export
 * @interface IReportSummaryDtoPlanOmnibusBalanceSummaryRecordDto
 */
export interface IReportSummaryDtoPlanOmnibusBalanceSummaryRecordDto {
    /**
     * 
     * @type {string}
     * @memberof IReportSummaryDtoPlanOmnibusBalanceSummaryRecordDto
     */
    employer_name?: string;
    /**
     * 
     * @type {Array<IPlanOmnibusBalanceSummaryRecordDto>}
     * @memberof IReportSummaryDtoPlanOmnibusBalanceSummaryRecordDto
     */
    employer_records?: Array<IPlanOmnibusBalanceSummaryRecordDto>;
    /**
     * 
     * @type {Array<IReportSummaryGroupDtoPlanOmnibusBalanceSummaryRecordDto>}
     * @memberof IReportSummaryDtoPlanOmnibusBalanceSummaryRecordDto
     */
    subsidiary_groups?: Array<IReportSummaryGroupDtoPlanOmnibusBalanceSummaryRecordDto>;
}

/**
 * Check if a given object implements the IReportSummaryDtoPlanOmnibusBalanceSummaryRecordDto interface.
 */
export function instanceOfIReportSummaryDtoPlanOmnibusBalanceSummaryRecordDto(value: object): value is IReportSummaryDtoPlanOmnibusBalanceSummaryRecordDto {
    return true;
}

export function IReportSummaryDtoPlanOmnibusBalanceSummaryRecordDtoFromJSON(json: any): IReportSummaryDtoPlanOmnibusBalanceSummaryRecordDto {
    return IReportSummaryDtoPlanOmnibusBalanceSummaryRecordDtoFromJSONTyped(json, false);
}

export function IReportSummaryDtoPlanOmnibusBalanceSummaryRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IReportSummaryDtoPlanOmnibusBalanceSummaryRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'employer_name': json['employer_name'] == null ? undefined : json['employer_name'],
        'employer_records': json['employer_records'] == null ? undefined : ((json['employer_records'] as Array<any>).map(IPlanOmnibusBalanceSummaryRecordDtoFromJSON)),
        'subsidiary_groups': json['subsidiary_groups'] == null ? undefined : ((json['subsidiary_groups'] as Array<any>).map(IReportSummaryGroupDtoPlanOmnibusBalanceSummaryRecordDtoFromJSON)),
    };
}

export function IReportSummaryDtoPlanOmnibusBalanceSummaryRecordDtoToJSON(json: any): IReportSummaryDtoPlanOmnibusBalanceSummaryRecordDto {
    return IReportSummaryDtoPlanOmnibusBalanceSummaryRecordDtoToJSONTyped(json, false);
}

export function IReportSummaryDtoPlanOmnibusBalanceSummaryRecordDtoToJSONTyped(value?: IReportSummaryDtoPlanOmnibusBalanceSummaryRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employer_name': value['employer_name'],
        'employer_records': value['employer_records'] == null ? undefined : ((value['employer_records'] as Array<any>).map(IPlanOmnibusBalanceSummaryRecordDtoToJSON)),
        'subsidiary_groups': value['subsidiary_groups'] == null ? undefined : ((value['subsidiary_groups'] as Array<any>).map(IReportSummaryGroupDtoPlanOmnibusBalanceSummaryRecordDtoToJSON)),
    };
}

